// extracted by mini-css-extract-plugin
var _1 = "PasswordTips_root__52e18";
var _2 = "PasswordTips_rule__17803";
export { _1 as "root", _2 as "rule" }
